import gql from "graphql-tag";

export const GET_PHONE_NUMBER = gql`
    query PhoneNumber($phoneNumberId: ID!){
        phoneNumber(phoneNumberId: $phoneNumberId) {
            phoneNumberId
            userId
            parentType
            parentId
            phoneNumberType
            phoneNumber
            primary
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const GET_PHONE_NUMBERS = gql`
    query PhoneNumbers($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        phoneNumbers(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            phoneNumberId
            userId
            parentType
            parentId
            phoneNumberType
            phoneNumber
            primary
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const GET_PHONE_NUMBERS_OF_PARENT = gql`
    query PhoneNumbersOfParent($parentType: String!, $parentId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        phoneNumbersOfParent(parentType: $parentType, parentId: $parentId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            phoneNumberId
            userId
            parentType
            parentId
            phoneNumberType
            phoneNumber
            primary
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

export const CREATE_PHONE_NUMBER = gql`
    mutation CreatePhoneNumber($newPhoneNumber: newPhoneNumber!) {
        createPhoneNumber(
            newPhoneNumber: $newPhoneNumber
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_PHONE_NUMBER = gql`
    mutation UpdatePhoneNumber($changedPhoneNumber: changedPhoneNumber!) {
        updatePhoneNumber(
            changedPhoneNumber: $changedPhoneNumber
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_PHONE_NUMBER = gql`
    mutation DeletePhoneNumber($deletePhoneNumberId: ID!) {
        deletePhoneNumber(
            deletePhoneNumberId: $deletePhoneNumberId
        ) {
            returnCode
            message
        }
    }
`;
